export default ({ app, store }, inject) => {
  inject('upload', (file, type, doc_type = null) => {
    const files = file
    if (!files.length) {
      return
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(files[0])

      const formData = new FormData()
      formData.append('type', type)
      formData.append('file', files[0])
      formData.append('doc_type', doc_type)

      app.$axios.post(process.env.ASYNC_BASE_URL_API +  process.env.BASE_URL_WITH_UUID + '/application/uploadFile', formData, { emulateHTTP: true })
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  })
}
